/**
 *
 * Asynchronously loads the component for ProfileScreen
 *
 */

import loadable from "../../utils/loadable";

export default loadable(() => import("./index"));
